import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { alpha, numeric } from 'vee-validate/dist/rules';

extend('alpha', alpha);
extend('numeric', numeric);

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    guestbookRules: {
      required: true,
    },
    residents: {
      required: true,
    },
  },
  data() {
    return {
      pickers: {
        date: false,
        start: false,
        end: false,
      },
      time: {
        date: null,
        start: null,
        end: null,
      },
      dialog: false,
      form: {
        visitType: '',
        visitors: [
          {
            id: uuidv4(),
            isPrimary: true,
            name: '',
            visitorPhone: '',
          },
        ],
        residentId: null,
      },
      today: moment(new Date()).format("YYYY-MM-DD"),
      now: moment(new Date()).format("HH:mm"),
      timeFormat: '',
      allowedResidents: []
    };
  },
  watch: {
    dialog(isOpened) {
      if (!isOpened) {
        this.$refs.form.reset();
        this.$refs.observer.reset();
      }
    },
    ['time.start'](start: string) {

      if(moment(this.time.start, 'h:mma') <= moment(this.guestbookRules.start, 'h:mma') || moment(this.time.start, 'h:mma') >= moment(this.guestbookRules.end, 'h:mma')) {
        this.time.start = moment(this.guestbookRules.start, 'h:mma')
          .format('HH:mm');
      }

      this.time.end = moment(start, 'h:mma')
        .add(1, 'h')
        .format('HH:mm');
    },
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    start() {
      return `${this.guestbookRules.start}:00`;
    },
    end() {
      return `${this.guestbookRules.end}:00`;
    },
    formattedStartTime(){
      if(!this.facility.timeFormat) return ''

      return moment(this.time.start, 'HH:mm').format(this.facility.timeFormat)
    },
    formattedEndTime(){
      if(!this.facility.timeFormat) return ''

      return moment(this.time.end, 'HH:mm').format(this.facility.timeFormat)
    },
    formattedStartDate(){
      if(!this.facility.dateFormat) return ''
  
      return moment(this.time.date).format(this.facility.dateFormat)
    }
  },
  methods: {
    visitTypeChange(typeName){
      const residentsIds = this.guestbookRules.visitTypes.find(x=>x.name == typeName).restrictedResidents || []
      this.allowedResidents = this.residents.filter(x=> !residentsIds.includes(x.id))
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      }

      const visit = { ...this.form };

      visit.residentName = this.residents.find(
        resident => resident.id === visit.residentId
      ).name;

      visit.visitors = visit.visitors.map(visitor => ({ ...visitor }));

      visit.preVisitSurveyId = this.guestbookRules.preVisitSurvey;

      visit.start = moment(`${this.time.date} ${this.time.start}`).toDate();
      visit.end = moment(`${this.time.date} ${this.time.end}`).toDate();

      await this.$store.dispatch('bookVisit', visit);

      this.dialog = false;
    },

    addVisitor() {
      this.form.visitors.push({
        id: uuidv4(),
        name: '',
        isPrimary: true,
        visitorPhone: '',
      });
    },

    removeVisitor(index) {
      this.form.visitors.splice(index, 1);
    },

    getAllowedDates(date) {
      if(!this.guestbookRules.monday && moment(date).isoWeekday() === 1) {
        return false;
      }
      if(!this.guestbookRules.tuesday && moment(date).isoWeekday() === 2) {
        return false;
      }
      if(!this.guestbookRules.wednesday && moment(date).isoWeekday() === 3) {
        return false;
      }
      if(!this.guestbookRules.thursday && moment(date).isoWeekday() === 4) {
        return false;
      }
      if(!this.guestbookRules.friday && moment(date).isoWeekday() === 5) {
        return false;
      }
      if(!this.guestbookRules.saturday && moment(date).isoWeekday() === 6) {
        return false;
      }
      if(!this.guestbookRules.sunday && moment(date).isoWeekday() === 7) {
        return false;
      }
      return moment(date).isSameOrAfter(moment().format('YYYY-MM-DD'))
    },

    open(date, start) {
      this.dialog = true;
      if(this.today < date) {
        this.time.date = date;
        this.time.start = start;
      } else if(this.today === date && this.now < start) {
        this.time.date = this.today;
        this.time.start = start;
      } else {
        this.time.date = this.today;
        this.time.start = this.now;
      }
    },
  },
  created(){
    this.$store.dispatch("getFacility");
  },
  mounted() {
    this.timeFormat = this.facility.timeFormat.includes('A')?'ampm':'24h'
    extend('minTime', {
      validate: value => {
        const start = moment(this.time.start, 'h:mma');
        const end = moment(this.time.end, 'h:mma');
        return (
          moment(end).isAfter(start) ||
          'Event end date cannot be before start date'
        );
      },
    });
  },
};
